import api from "../_axios";

const LiveURL = "https://backend.eduvalu.com/api/v1";
const TestURL = "https://server.eduvalu.com/api/v1";
const LocalURL = "http://localhost:8000/api/v1";

const resolvedApiURL =
  process.env.NEXT_PUBLIC_API_URL ||
  process.env.NEXT_PUBLIC_API_BASE_URL ||
  LiveURL ||
  TestURL ||
  LocalURL;

const getCities = () => api.get(`${resolvedApiURL}/api/v1/cities`);
const getAreas = (cityid: number) =>
  api.get(`${resolvedApiURL}/api/v1/areas/${cityid}`);
const getLanguages = () => api.get(`${resolvedApiURL}/api/v1/languages`);
const getMainEducationTypes = () =>
  api.get(`${resolvedApiURL}/api/v1/type-educations`);
const getEducationTypes = (school_year_id: any) =>
  api.get(
    `${resolvedApiURL}/api/v1/education-types?school_year_id=${school_year_id}`,
  );
const getSchoolYears = (mainEducationType?: number, teacherId?: number) =>
  api.get(
    `${resolvedApiURL}/api/v1/school-years?teacher_id=${
      teacherId ? teacherId : ""
    }&type_education_id=${mainEducationType ? mainEducationType : ""}`,
  );
const getSchoolTypes = () => api.get(`${resolvedApiURL}/api/v1/school-types`);

const GENERALAPI = {
  getCities,
  getAreas,
  getLanguages,
  getMainEducationTypes,
  getEducationTypes,
  getSchoolYears,
  getSchoolTypes,
};
export default GENERALAPI;
